import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import ErrorAlert from "../../toolkit/ErrorAlert";
import ListViewHeader from "../ListViewHeader";
import baseTheme from "../../themes/baseTheme";
import EditCol from "./EditCol";

const { palette } = baseTheme;
const padding = "16px 24px";

export default function ResultsListView({
  headers = [],
  rows = [],
  ListItem,
  setTrg,
  Trg,
  ...props
}) {
  const [showEditCol, setShowEditCol] = useState(false);
  const [headersWithWidth, setHeadersWithWidth] = useState([]);

  useEffect(() => {
    setShowEditCol(
      !!rows.find((r) => r.isEditable?.isVisible || r.isDeletable?.isVisible)
    );
  }, [rows]);

  useEffect(() => {

    const newHeaders = [...headers];
    if (showEditCol) {
      newHeaders.push({ id: "editCol" });
    }
    const allColsHaveWdith = !headers.find((h) => !h.width);
    if (!allColsHaveWdith) {
      const colWidth = Math.floor(100 / newHeaders.length);
      newHeaders.forEach((h) => (h.width = `${colWidth}%`));
    }
    const hasHeaderText = headers.find((h) => h.text);
    if (hasHeaderText) setHeadersWithWidth(newHeaders);
  }, [headers, showEditCol]);

  if (!ListItem) {
    return (
      <ErrorAlert
        severity="error"
        message="ListItemComponent not provided to CollectionsTemplate"
      />
    );
  }
  return (
    <>
      {headersWithWidth.length > 0 && (
        <ListViewHeader key={headers.id} headers={headersWithWidth} padding={padding} />
      )}
      <Box className="collections-list-view">
        {rows.map((row, i) => (
          <ListItem
            className="list-item"
            key={row.key}
            headers={headersWithWidth}
            setTrg={setTrg}
            Trg={Trg}
            {...row}
            {...props}
          >
            {showEditCol && <EditCol {...row} {...props} />}
          </ListItem>
        ))}
      </Box>
    </>
  );
}
